// When clicking on a button (or any other node with a few exceptions):
// 1. First click sets the cursor position
//
// 2. Double click selects the entire word under the cursor - on inserting new
// text it will replace the text in the button.
// Does not remove the button when there's just a single word in the button.
//
// 3. Triple click expands the selection to include the entire "paragraph" and
// beginning of next node - on input, it will replace the entire button, which
// is unexpected.
//
// With this plugin, even on triple click, the selection will be kept inside of
// the button, so it won't delete the button when users start typing
export default () => ({
  onClick(event, editor, next) {
    const selection = editor.value.selection

    // must be selection made with a triple click
    if (!selection || event.detail < 3) {
      return next()
    }

    // must be a hanging range (ends on beginning of next block)
    const { anchor, focus } = selection
    if (!(anchor.offset === 0 && focus.offset === 0)) {
      return next()
    }

    // must select exactly two blocks
    const selectedBlocks = editor.value.document.getLeafBlocksAtRange(selection)
    if (selectedBlocks.size !== 2) {
      return next()
    }

    // unhang selection when triple click happened on the button
    const button = selectedBlocks.first()
    if (button.type === "button") {
      editor.moveToRangeOfNode(button)
    }

    next()
  }
})
